import { CONFIG } from '../../config';

export const PURCHASE_ORDERS = `${CONFIG.API}/purchase-orders`;
export const REQUEST_CHANGE = `${CONFIG.API}/request-changes`;
export const SHIPPING_LABEL = `${CONFIG.API}/shipping-label/shipments`;
export const SUBMIT_SHIPPING = `${CONFIG.API}/shipping-authorization/submit`;
